<div class="modal-content modal-milvus">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-title-default">
      {{ "CONTATOS" | translate }}
    </h6>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
      <i class="mdi mdi-close"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between">
          <h6 class="modal-title">{{ "PESQUISA" | translate }}</h6>
          <div>
            <button type="button" class="btn btn-integration badge-pill"
              [disabled]="!permissao.VincularContatos || contatosSelecionados.length < 2" (click)="vincularContatos()">
              <span>{{ "VINCULAR" | translate }}</span>
            </button>
            <button type="button" class="btn btn-success badge-pill"
              [disabled]="!permissao.CriarNovoContatoChat"
              (click)="abrirModalContato()">
              <span>{{ "NOVO_CONTATO" | translate }}</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="navbar-search navbar-search-light form-inline my-3" id="navbar-search-main">
              <div class="form-group mb-0" style="width: 100%">
                <div class="input-group input-group-merge" style="width: 100%">
                  <div class="input-group-prepend">
                    <span class="input-group-text prepend-menu-search"><i class="fas fa-search"></i></span>
                  </div>
                  <input class="form-control input-menu-search"
                    placeholder="{{ 'PLACEHOLDER_NOME_CLIENTE_CPF_CELULAR_TELEFONE' | translate }}" type="text"
                    name="search" [(ngModel)]="searchText" (ngModelChange)="changePesquisa($event)" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive table-listagem">
          <table class="table align-items-center table-flush" style="margin-bottom: 0; overflow: hidden;">
            <thead class="thead-light">
              <tr>
                <th style="padding-left: 18px; padding-top: 9px; padding-bottom: 9px;" class="w-5">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="seleciona-todos" (click)="selecionaTodos()">
                    <label class="custom-control-label" for="seleciona-todos"></label>
                  </div>
                </th>
                <th scope="col" [translate]="'CONTATO'"></th>
                <th
                  *ngIf="solicitantes_habilitados.solicitante_contato || solicitantes_habilitados.solicitante_operador"
                  scope="col">CPF</th>
                <th *ngIf="solicitantes_habilitados.solicitante_cliente" scope="col" [translate]="'CLIENTE'"></th>
                <th scope="col" [translate]="'CELULAR'"></th>
                <th scope="col" [translate]="'TELEFONE'"></th>
                <th scope="col" [translate]="'EMAIL'"></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista; let i = index">
                <td style="padding-left: 18px;">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="{{'seleciona-contato-'+i}}"
                      (change)="selecionaContato($event.target.checked, item.id)">
                    <label class="custom-control-label" for="{{'seleciona-contato-'+i}}"></label>
                  </div>
                </td>
                <td>
                  <div container=".modal"
                    [ngbTooltip]="item.descricao && item.descricao.length > 20 ? item.descricao : null">
                    {{ item.descricao | ellipsis : 20 }}
                  </div>
                </td>
                <td
                  *ngIf="solicitantes_habilitados.solicitante_contato || solicitantes_habilitados.solicitante_operador">
                  {{ item.cpf | mask: '000.000.000-00' | null }}</td>
                <td *ngIf="solicitantes_habilitados.solicitante_cliente">
                  <div container=".modal"
                    [ngbTooltip]="item.cliente_nome && item.cliente_nome.length > 20 ? item.cliente_nome : null">
                    {{ item.cliente_nome | ellipsis : 20 | null }}
                  </div>
                </td>
                <td>{{ item.celular | phone : item.codigo_pais | null }}</td>
                <td>{{ item.telefone | phone : item.codigo_pais_telefone | null }}</td>
                <td>
                  <div container=".modal"
                    [ngbTooltip]="item.email && item.email.length > 20 ? item.email : null">
                    {{ item.email ? (item.email | ellipsis:20) : '---' }}
                  </div>
                </td>
                <td class="text-right">
                  <button type="button" class="btn btn-darkblue rounded-circle btn-icon-only"
                    [disabled]="!permissao.EditarContatoChat"
                    (click)="abrirModalContato(item)" container=".modal" [ngbTooltip]="('EDITAR_CONTATO' | translate)">
                    <i class="fa-solid fa-pen"></i>
                  </button>
                  <button type="button" class="btn btn-darkgray rounded-circle btn-icon-only ml-0"
                    [disabled]="!item.email || !integracaoEmailChatDisponivel"
                    (click)="abrirConversaEmailPorSaida(item)" container=".modal"
                    [ngbTooltip]="('INICIAR_CONVERSA' | translate) + ' Email'">
                    <i style="font-size: 23px; margin-top: 2px;" class="fa-regular fa-envelope"></i>
                  </button>
                  <button type="button" class="btn btn-success rounded-circle btn-icon-only"
                    (click)="abrirConversaPorSaida(item)" container=".modal" [ngbTooltip]="('CONVERSAR' | translate)">
                    <i style="font-size: 23px; margin-top: 2px;" class="fa-brands fa-whatsapp"></i>
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td [colSpan]="obterQuantidadeColunasTabelaContatos()"
                  style="font-size: 16px; padding: 0 14px 0 18px;">
                  <pagination *ngIf="lista.length > 0" [meta]="contatosPagination"
                    (pageChange)="paginarListagem($event)">
                  </pagination>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>